module.exports = __webpack_public_path__ + "img/bghe2.9a7284a2.png";